import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brand-valorant', 'BrandValorant', [["path",{"d":"M14.5 14h4.5l2 -2v-6l-6.5 8"}],["path",{"d":"M9 19h5l-11 -13v6l6 7"}]]);